import {
    LOGIN_SUCCESS,
    LOGIN_FAIL,
    AUTH_ERROR,
    USER_LOADED
  } from "../actions/types";
  
  const initialState = {
    token: localStorage.getItem("token"),
    isAuthenticated: null,
    loading: true,
    user: null,
  };
  
  export default function auth(state = initialState, action) {
    const { type, payload } = action;
    switch (type) {
      case USER_LOADED:
        return {
          ...state,
          isAuthenticated: true,
          loading: false,
          user: payload,
        };
      case LOGIN_SUCCESS:
      case LOGIN_SUCCESS:
        localStorage.setItem("token", payload.token);
        return { ...state, ...payload, isAuthenticated: true, loading: false };
      //  case LOGIN_FAIL:
      case LOGIN_FAIL:
      case AUTH_ERROR:
        localStorage.clear();
        return { ...state, token: null, isAuthenticated: false, loading: false };
    
  
      default:
        return state;
    }
  }
  